import { AlertController } from "./AlertController";
import { AppController } from "./AppController";
import { AuthController } from "./AuthController";
import { GTagController } from "./GTagController";
import { LanguageController } from "./LanguageController";
import { LoaderController } from "./LoaderController";
import { MediaController } from "./MediaController";
import { MenuController } from "./MenuController";
import { ModalController } from "./ModalController";
import { PageController } from "./PageController";
import { OutreachController } from "./PageControllers/Outreach/OutreachController";
import { MailController } from "./PageControllers/Outreach/MailController";
import { ReportController } from "./PageControllers/Outreach/ReportController";
import { ResearchController } from "./PageControllers/Outreach/ResearchController";
import { SimpleAuthController } from "./SimpleAuthController";
import { ThemeController } from "./ThemeController";
import { UserController } from "./UserController";
import { CompensationController } from "./PageControllers/CompensationController";

class ControllersImpl {
  
    private _app: AppController
    private _media: MediaController;
    private _alert: AlertController;
    private _menu: MenuController;
    private _page: PageController;
    private _auth: AuthController;
    private _user: UserController;
    private _language: LanguageController;
    private _loading: LoaderController;
    private _modals: ModalController;
    private _simpleAuth: SimpleAuthController;
    private _gTag: GTagController;

    private _outreach: OutreachController;
    private _mail: MailController;
    private _report: ReportController;
    private _research: ResearchController;
    private _theme: ThemeController;
    private _compensation: CompensationController;

    constructor() {
        this._app = new AppController();
        this._media = new MediaController();
        this._alert = new AlertController()
        this._menu = new MenuController();
        this._page = new PageController();
        this._auth = new AuthController();
        this._user = new UserController();
        this._language = new LanguageController();
        this._loading = new LoaderController();
        this._modals = new ModalController();
        this._simpleAuth = new SimpleAuthController();
        this._gTag = new GTagController()

        this._outreach = new OutreachController()
        this._mail = new MailController()
        this._report = new ReportController()
        this._research = new ResearchController()
        this._theme = new ThemeController()
     
        this._compensation = new CompensationController()
    }

    get app(){
        return this._app
    }
    
    get media(){
        return this._media
    }

    get alert(){
        return this._alert
    }

    get menu(){
        return this._menu
    }

    get page(){
        return this._page
    }

    get auth(){
        return this._auth
    }

    get user(){
        return this._user
    }

    get language(){
        return this._language
    }

    get load(){
        return this._loading
    }

    get modals(){
        return this._modals
    }

    get simpleAuth(){
        return this._simpleAuth
    }

    get gTag(){
        return this._gTag
    }


    get outreach(){
        return this._outreach
    }

    get mail(){
        return this._mail
    }

    get report(){
        return this._report
    }

    get research(){
        return this._research
    }

    get theme(){
        return this._theme
    }

    get compensation(){
        return this._compensation
    }
}
  
// @ts-ignore
global.__app__ = global.__app__ || {};
// @ts-ignore
global.__app__.controllers =
// @ts-ignore
global.__app__.controllers || new ControllersImpl();

export function controllers(): ControllersImpl {
    // @ts-ignore
    return global.__app__.controllers;
}
  